import store from "@frameworks/web/redux/store";
import { NET_POSITIONS, NET_POSITIONS_ERROR, NET_POSITIONS_HIDE_ERROR, NET_POSITIONS_START_LOADER, NET_POSITIONS_STOP_LOADER, } from "../interface/INetPositions";
class NetPositionsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getPositions(data) {
        this.dispatch({
            type: NET_POSITIONS,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: NET_POSITIONS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: NET_POSITIONS_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: NET_POSITIONS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: NET_POSITIONS_STOP_LOADER,
        });
    }
}
export default NetPositionsActions;
